import { render, staticRenderFns } from "./oddsanalysis.vue?vue&type=template&id=a704e224&scoped=true"
import script from "./oddsanalysis.vue?vue&type=script&lang=js"
export * from "./oddsanalysis.vue?vue&type=script&lang=js"
import style0 from "./oddsanalysis.vue?vue&type=style&index=0&id=a704e224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a704e224",
  null
  
)

export default component.exports